import React from 'react';
import PropTypes from 'prop-types'; 
import AuthContextProvider from './AuthContext'; 
import MealContextProvider from './MealContext';
import GlobalContextProvider from './GlobalContext';
import BookingContextProvider from './BookingContext';
import ThemeContextProvider from './ThemeContext';
import PermissionContextProvider from './PermissionContext';
import SideBarRefreshContextProvider from './SideBarRefreshContext';

const AppContextProvider = ({ children }) => (
  <SideBarRefreshContextProvider>
    <GlobalContextProvider>
      <ThemeContextProvider>
        <AuthContextProvider>
          <PermissionContextProvider>
            <BookingContextProvider>
              <MealContextProvider>
                {children}  
              </MealContextProvider>
            </BookingContextProvider>
          </PermissionContextProvider>
        </AuthContextProvider>
      </ThemeContextProvider>
    </GlobalContextProvider>
  </SideBarRefreshContextProvider>

 
  
  );

AppContextProvider.propTypes = {
  children: PropTypes.node.isRequired, 
};

export default AppContextProvider;
